/* eslint-disable max-lines-per-function */
import React from 'react';

import Image from 'next/image';

import { useRouter } from 'nextjs-toploader/app';

import { type VendorItemResponse } from '@/common/apis/storefronts/v1/get-vendor.api';
import CommonLightCard from '@/common/components/light-card';
import Wrapper from '@/common/components/wrapper';

export default function StoreInfo({ item }: { item?: VendorItemResponse }) {
  const router = useRouter();
  return (
    <>
      {item && (
        <Wrapper className="mb-4 hidden !h-auto lg:!block lg:px-0">
          <CommonLightCard className="!border-none !bg-transparent !p-0">
            <CommonLightCard.Body className="w-full !flex-row items-center justify-between lg:!mt-0 ">
              <CommonLightCard.Item
                className="cursor-pointer"
                onClick={() => {
                  router.push(`/${item.slug}`);
                }}
              >
                <CommonLightCard.Icon className="overflow-hidden lg:h-[36px] lg:w-[36px]">
                  <Image
                    src={
                      item?.vendorMedia?.vendorLogo?.url ??
                      '/assets/images/png/sample-logo.png'
                    }
                    className="lg:h-[36px] lg:w-[36px] lg:rounded-[12px]"
                    width={36}
                    height={36}
                    alt="Logo"
                  />
                </CommonLightCard.Icon>
                <CommonLightCard.Title className="!text-sm !font-semibold lg:!text-xs lg:!text-[#174170] ">
                  {item.vendorName}
                </CommonLightCard.Title>
              </CommonLightCard.Item>
            </CommonLightCard.Body>
          </CommonLightCard>
        </Wrapper>
      )}
    </>
  );
}
